<div class="flex flex-col flex-auto w-full max-w-7xl mx-auto p-4 lg:p-8">
    <h2 class="text-3xl font-bold mb-6">Integracje</h2>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

        <!-- REST API Card -->
        <div class="flex flex-col bg-card shadow rounded-2xl overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
            routerLink="rest-api">
            <div class="p-6">
                <div class="flex items-center justify-between mb-4">
                    <div class="w-12 h-12 rounded-full bg-primary-50 dark:bg-primary-900/30 flex items-center justify-center text-primary-600 dark:text-primary-400">
                        <mat-icon svgIcon="heroicons_outline:code-bracket-square"></mat-icon>
                    </div>
                    <span class="px-3 py-1 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 text-xs font-medium rounded-full">Aktywne</span>
                </div>
                <h3 class="text-xl font-semibold mb-2">REST API</h3>
                <p class="text-secondary text-sm mb-6">
                    Zarządzaj kluczami dostępu, webhookami i monitoruj ruch w API, aby integrować Fakturnię z własnymi
                    aplikacjami.
                </p>
                <div class="flex items-center text-primary-600 dark:text-primary-400 font-medium text-sm">
                    <span>Przejdź do konfiguracji</span>
                    <mat-icon svgIcon="heroicons_outline:arrow-right" class="icon-size-4 ml-1"></mat-icon>
                </div>
            </div>
        </div>

    </div>
</div>